import React from 'react'
import Hero from '../2.Hero/Hero'
import AboutUs from '../3.AboutUs/AboutUs'
import Contact from '../4.Contact/Contact'

const Home = () => {
    return (
      <>
        <Hero />
        <AboutUs />
        <Contact />
      </>
    );
}

export default Home